// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__qCR7A","input":"styles_input__74AA8"};